import { render, staticRenderFns } from "./SignatureVerification.vue?vue&type=template&id=09ef53be&scoped=true&"
import script from "./SignatureVerification.vue?vue&type=script&lang=js&"
export * from "./SignatureVerification.vue?vue&type=script&lang=js&"
import style0 from "./SignatureVerification.vue?vue&type=style&index=0&id=09ef53be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef53be",
  null
  
)

export default component.exports